import React, { useEffect, useState } from 'react';
import GlobalWrapper from '../../../components/Wrapper/GlobalWrapper';
import { Alert, Box, Button, Paper, Stack, Typography } from '@mui/material';
import GlobalDatagrid from '../../../components/mui/DataGrid/GlobalDatagrid';
import { useSelector } from 'react-redux';
import useResponsive from '../../../Hooks/useResponsive';
import { useDispatch } from 'react-redux';
import { getLeadsForDeo } from '../../../redux/features/deoSlice';
import dayjs from 'dayjs';
import FromAndToDatePicker from '../../../components/mui/FromAndToDatePicker';
import ActionDetails from '../../../components/mui/GlobalAnchor/ActionDetails';
import GlobalAnchorList from '../../../components/mui/GlobalAnchor/GlobalAnchorList';
import { Icon } from '@iconify/react/dist/iconify.js';
import { useNavigate } from 'react-router-dom';
import { skillxDeoleadsTableHeader } from '../../../components/datagrid/deo/skillxDeoleadsTableHeader';
import SkillxAddorEditDeoLeads from '../../../components/datagrid/deo/SkillxAddorEditDeoLeads';
import BulkUploadView from '../BulkUploadView';
import GlobalDialog from '../../../components/mui/Dialogue/GlobalDialog';

const SkillxDeoLeads = () => {
  const navigate = useNavigate('');
  const mdDown = useResponsive('down', 'md');
  const [fromDate, setFromDate] = useState(dayjs().startOf('month').format('YYYY-MM-DD'));
  const [toDate, setToDate] = useState(dayjs().endOf('month').format('YYYY-MM-DD'));
  const [direction, setDirection] = useState('row');
  const dispatch = useDispatch();
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { gridSize, pageNum, rowData, openAnchor, search } = paginationData;
  const { resData, loading } = useSelector((store) => store.deo);
  const { data, meta } = resData;
  const dispatchParams = {
    paginationData,
    fromDate,
    toDate,
  };
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertContent, setAlertContent] = useState({
    title: '',
    message: '',
    data: null,
  });
  const handleAlertClose = () => {
    setAlertOpen(false);
    setAlertContent({ title: '', message: ''  ,data: null});
  };

  useEffect(() => {
    if (mdDown) {
      setDirection('column');
    } else {
      setDirection('row');
    }
  }, [mdDown]);

  useEffect(() => {
    if (pageNum && gridSize) {
      dispatch(getLeadsForDeo(dispatchParams));
    }
  }, [gridSize, pageNum, search]);

  return (
    <GlobalWrapper
      title="SkillX Deo Leads"
      actions={
        <Stack gap={1}>
          <SkillxAddorEditDeoLeads
            dispatchParams={dispatchParams}
            setAlertOpen={setAlertOpen}
            setAlertContent={setAlertContent}
          />
          <BulkUploadView
            dispatchParams={dispatchParams}
            setAlertOpen={setAlertOpen}
            setAlertContent={setAlertContent}
          />
        </Stack>
      }
    >
      <Box sx={{ display: 'flex', flexDirection: direction }}>
        <Box sx={{ flex: 0.5 }}>
          <FromAndToDatePicker
            fullWidth={true}
            disabled={false}
            fromDate={fromDate}
            toDate={toDate}
            setFromDate={setFromDate}
            setToDate={setToDate}
          />
        </Box>
      </Box>
      <Box mt={2}>
        <Paper elevation={3}>
          <GlobalDatagrid
            tableHead={skillxDeoleadsTableHeader}
            rows={data || []}
            meta={meta?.totalRecords}
            rowUniqueId="sl_no"
            loading={loading}
            rowClick={true}
            actionComponent={
              <>
                <ActionDetails val={rowData?.lead_name} />
                <GlobalAnchorList
                  label="Update"
                  component={<SkillxAddorEditDeoLeads dispatchParams={dispatchParams} row={rowData} />}
                />
                {/* <GlobalAnchorList
                  component={
                    <Box>
                      <Button
                        sx={{
                          p: '7px',
                          px: '10px',
                          background: 'linear-gradient(135deg, #2f72b3, #1e65ab6e)',
                          color: '#fff',
                          '&:hover': {
                            background: 'linear-gradient(135deg,rgb(7, 71, 136),rgba(4, 19, 34, 0.43))',
                          },
                        }}
                        onClick={() => navigate(`/assessment-tool/student-registration`)}
                        variant="outlined"
                      >
                        <Icon icon="mingcute:user-search-fill" width="20" height="20" />
                        Go To Take Assessment
                      </Button>
                    </Box>
                  }
                /> */}
              </>
            }
          />
        </Paper>
      </Box>
      {alertOpen && (
        <Box>
          <GlobalDialog
            maxWidth={'sm'}
            fullWidth
            title={alertContent.title}
            open={alertOpen}
            setOpen={setAlertOpen}
            closeButton={true}
            closeCondition={handleAlertClose}
            content={
              <>
                {/* <Typography sx={{ mb: 2 }}>{alertContent.message}</Typography> */}
                <Alert severity="info">{alertContent.message}</Alert>

                {alertContent.data?.skippedLeads?.length > 0 && (
                  <>
                    <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1,mt:1.5 }}>
                      Skipped Leads (Already Exist)
                    </Typography>

                    {alertContent.data.skippedLeads.map((lead, index) => (
                      <Box
                        key={index}
                        sx={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          border: '1px solid',
                          borderColor: 'divider',
                          borderRadius: 1,
                          p: 1,
                          mb: 1,
                        }}
                      >
                        <Typography>{lead.name}</Typography>
                        <Typography color="text.secondary">{lead.phone}</Typography>
                      </Box>
                    ))}
                  </>
                )}
              </>
            }
          />
        </Box>
      )}
    </GlobalWrapper>
  );
};

export default SkillxDeoLeads;
